<template>
  <small class="datakilde ods-flex">
    <span class="datakilde__text">
      <span v-if="hasDateInTranslation">
        {{ $t(`${translationPath}.tekst`, { dato: displayDate }) }}
      </span>
      <span v-else>
        {{ $t(`${translationPath}.tekst`) }}
      </span>
      <a
        v-if="hasLinkInTranslation"
        :href="$t(`${translationPath}.link.url`)"
        :target="hasTargetTranslation ? $t(`${translationPath}.link.target`) : '_blank'"
        :title="
          hasTitleTranslation
            ? $t(`${translationPath}.link.title`)
            : `Følg lenken til ${$t(`${translationPath}.link.tekst`)}`
        "
      >
        {{ $t(`${translationPath}.link.tekst`) }}
      </a>
    </span>
  </small>
</template>

<script>
export default {
  name: 'DataKildeInfo',

  props: {
    translationPath: {
      type: String,
      required: true,
    },
    date: {
      type: Date,
      required: false,
      default: () => new Date(),
    },
  },

  computed: {
    displayDate() {
      return this.$minside.formatDateAndTime(this.date);
    },

    hasLinkInTranslation() {
      return this.$te(`${this.translationPath}.link.url`);
    },

    hasTargetTranslation() {
      return this.$te(`${this.translationPath}.link.target`);
    },

    hasTitleTranslation() {
      return this.$te(`${this.translationPath}.link.title`);
    },

    hasDateInTranslation() {
      return (
        this.$te(`${this.translationPath}.tekst`) &&
        this.$t(`${this.translationPath}.tekst`, { dato: '{dato}' }).includes('{dato}')
      );
    },
  },
};
</script>

<style scoped lang="scss">
.datakilde {
  margin: 0.5rem 0;
  line-height: 1.5em !important;

  & + & {
    margin-top: -0.25rem;
  }
}
</style>
